import * as React from "react";
import * as moment from "moment";
import { observer } from "mobx-react";
import { AppStore } from "../../stores/AppStore";
import { observable } from "mobx";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup, Icon, Tab, Tabs } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { IEmpresa, newEmpresa } from "../../model";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { toast } from "react-toastify";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj, formatCpfOrCnpj } from "../../utils";
import MensagensDetPage from "./MensagensDetPage";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";
import { DetStore } from "../../stores/det/DetStore";

@observer
export default class DetPage extends React.Component<{}, {}> {

  obs = observable({
    tasks_page: 1 as number,
    selectEmpresa: newEmpresa() as IEmpresa,
    erros: [] as any,
    view_erros: false as boolean,
  })

  constructor(props: any) {
    super(props);
    AppStore.setTitle("Domicílio Eletrônico Trabalhista (DET)");
  }

  async componentDidMount() {

    if (DetStore.obs.mensagens_pendentes.length > 0) {
      DetStore.obs.open_empresas_mensagens = true
    }

    DetStore.obs.mensagens_det = []
    DetStore.obs.mensagens_length = 0

    this.obs.tasks_page = 1

    await DetStore.handleTasksPaged(1, null);


  }

  handleBuscaTarefasPaged = async (page: number) => {

    this.obs.tasks_page = page

    DetStore.obs.loading_tasks = true

    await DetStore.handleTasksPaged(page, this.obs.selectEmpresa.cnpj);

  };

  handleBuscaTarefas = async (empresa) => {

    this.obs.selectEmpresa = empresa

    DetStore.obs.loading_tasks = true

    await DetStore.handleTasksPaged(1, this.obs.selectEmpresa.cnpj);

  };

  onCloseErros() {

    this.obs.view_erros = false

    this.obs.erros = []

  }

  async handleChangeTab(tabId: string) {

    DetStore.obs.selectedTab = tabId

  }

  handleAtualizaTarefasPaged = async () => {

    DetStore.obs.loading_tasks = true

    await DetStore.handleTasksPaged(this.obs.tasks_page, this.obs.selectEmpresa.cnpj);

  };

  render() {

    function statusFormatter(cell, row) {

      return getTag(row.status, row.tipo);

    }

    function dateFormatter(cell, row) {
      return moment(cell).format("DD/MM/YYYY") + " ás " + moment(cell).format("HH:mm");
    };

    function cnpjFormatter(cell, row) {
      return formatCpfOrCnpj(cell)
    };

    function empresaForatter(cell, row) {

      if (row.cnpj) {

        let emp = EmpresaStore.getByCnpj(row.cnpj);

        if (emp) {
          return `${emp.razao_social.substring(0, 60)}`
        }

      }

      return ""

    };

    let empresaText = this.obs.selectEmpresa.cnpj != ""
      ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
      : "Selecione uma empresa";

    const buttonFormaterError = (cell, row) => {
      return (
        <>
          <MDBBtn
            disabled={!row.error}
            color="default"
            rounded
            size="sm"
            onClick={(e) => handleViewDetalhes(row)}
          >
            <img src="/images/view.png" width="18px" />
          </MDBBtn>
        </>
      );
    }


    const handleViewDetalhes = async (row: any) => {
      this.obs.erros = row.erros || [row.error]

      if (this.obs.erros.length > 0) {
        this.obs.view_erros = true
      } else {
        toast.warn("Nenhum erro encontrado!", {});
        return
      }
    };

    return (
      <>
        <Tabs
          id="tabs"
          className={"tabsCalculos"}
          selectedTabId={DetStore.obs.selectedTab}
          onChange={(tabId) => this.handleChangeTab(String(tabId))}
        >
          <Tab
            id="tarefas"
            title="Solicitações"
            panel={<>
              <MDBRow>
                <MDBCol md="4">
                  <FormGroup className="empresaSelect" label="Empresa">
                    <EmpresaSelect
                      items={EmpresaStore.sortedEmpresas}
                      itemRenderer={renderEmpresa}
                      itemPredicate={filterEmpresa}
                      onItemSelect={(e: IEmpresa) => this.handleBuscaTarefas(e)}
                      inputProps={{ placeholder: "Filtrar uma empresa" }}
                    >
                      <Button
                        text={empresaText}
                        alignText={Alignment.LEFT}
                        rightIcon={
                          this.obs.selectEmpresa.cnpj ? (
                            <Icon
                              className="clear-icon-empresa"
                              icon="cross"
                              onClick={(ev) => {
                                ev.stopPropagation();
                                this.handleBuscaTarefas(newEmpresa());
                              }}
                            />
                          ) : (
                            <Icon icon="double-caret-vertical" style={{ padding: 5 }} />
                          )
                        }
                      />
                    </EmpresaSelect>
                  </FormGroup>
                </MDBCol>
                <MDBCol md="2">
                  <MDBBtn
                    className="btnDefault btnBuscarNfe mt25"
                    onClick={() => this.handleAtualizaTarefasPaged()}
                  >
                    Atualizar
                  </MDBBtn>
                </MDBCol>
              </MDBRow>

              <div>
                <BootstrapTable className="TableDefault" ref="table" data={DetStore.obs.tasks_det}>
                  <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={cnpjFormatter} dataField="cnpj" width="40%">CNPJ</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={empresaForatter} dataField="razao_social" width="40%">Razão Social</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data Solicitação</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={dateFormatter} dataField="_modifiedTS" width="20%">Ultima Atualização</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={statusFormatter} width="30%">Status</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={buttonFormaterError} width="10%">Erros</TableHeaderColumn>
                </BootstrapTable>
              </div>

              <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                <Pager
                  currentPage={this.obs.tasks_page}
                  totalCount={DetStore.obs.tasks_length}
                  pageSize={15}
                  onPageChange={page => this.handleBuscaTarefasPaged(page)} />
              </div>
            </>} />

          <Tab
            id="mensagens"
            title="Mensagens"
            panel={<MensagensDetPage />}
          />

        </Tabs>

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.view_erros}
          onConfirm={() => this.onCloseErros()}
          onClose={() => this.onCloseErros()}
          canOutsideClickCancel={true}
          className="AlertUser"
          intent="primary"
        >
          <h3 className="titleProccess titleCnae">Logs Erros</h3>
          <br />
          {this.obs.erros.map(values => {
            return (<p>{values}</p>)
          })}
        </Alert>

        <Dialog
          isOpen={DetStore.obs.open_empresas_mensagens}
          onClose={() => DetStore.obs.open_empresas_mensagens = false}
          title={"Contribuintes com mensagens"}
          className="modal-mensagens"
        >
          <div className={Classes.DIALOG_BODY}>
            <div className="table-mensagens">
              <div className="dropdownNotification text-mensagens">
                {DetStore.obs.mensagens_pendentes?.map((el: any) => {
                  let empresa = EmpresaStore.getByCnpj(el.cnpj)
                  if (empresa) {
                    return (
                      <>
                        <p>
                          Contribuinte
                          {" "}<b>{empresa.razao_social} - ({formatCnpj(el.cnpj)})</b>{" "}
                          {el.count == 0 && `não possui mensagens.`}
                          {el.count == 1 && `possui ${el.count} mensagem.`}
                          {el.count >= 2 && `possui ${el.count} mensagens.`}
                        </p>
                      </>
                    )
                  }
                })}
              </div>
            </div>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => DetStore.obs.open_empresas_mensagens = false} />
            </div>
          </div>
        </Dialog>

        <LoadingModal open={DetStore.obs.loading_tasks} onClose={() => DetStore.obs.loading_tasks = false} title={"Buscando solicitações"} />

      </>
    )
  }
}

